import { Filter } from '@src/pages/[...slug]/components/collection/domains/CollectionFilter'
import { EXPERIMENTS, getAssignedExperimentBucket } from '@src/experiments'
import { PRODUCT_FILTER_KEYS } from '@src/quince-site-common/src/constants/product'
import useExperimentBucket from '@src/quince-site-common/src/hooks/useExperimentBucket'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

const experimentName = EXPERIMENTS.CATEGORY_AND_DEPTS_FILTER_EXP.experimentName

export function getShouldHideDeptAndCategoryExp() {
  if (!isBrowser()) return false
  const categoryAndDeptFilterBucket = getAssignedExperimentBucket(experimentName)
  return categoryAndDeptFilterBucket === EXPERIMENTS.CATEGORY_AND_DEPTS_FILTER_EXP.bucketNames.control
}

export function useShouldHideDeptAndCategoryFilter() {
  const categoryAndDeptFilterBucket = useExperimentBucket(
    experimentName,
    EXPERIMENTS.CATEGORY_AND_DEPTS_FILTER_EXP.bucketNames.show,
  )
  return categoryAndDeptFilterBucket === EXPERIMENTS.CATEGORY_AND_DEPTS_FILTER_EXP.bucketNames.control
}

export function filterListOnExp(filterList: Filter[], hideDeptAndCategoryFilter: boolean) {
  return hideDeptAndCategoryFilter
    ? filterList.filter(filter => {
        return ![PRODUCT_FILTER_KEYS.categories, PRODUCT_FILTER_KEYS.departments].includes(filter.name)
      })
    : filterList
}
